export const FAIRTRADE_FONT_STACK =
  '"Exo 2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif'

export const FAIRTRADE_TITLE_FONT_STACK =
  '"Alegreya Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif'

export const FAIRTRADE_LEAF_GREEN = '#D4FF47'
export const FAIRTRADE_SKY_BLUE = '#0FC0FC'
